import type { Hit as AlgoliaHit } from 'instantsearch.js'
import React from 'react'
import { InstantSearch, Configure } from 'react-instantsearch'

import CustomPagination from '@components/algolia-search/CoursePagination'
import CustomSearchBox from '@components/algolia-search/CustomSearchBox'

import i18n from '@src/config/i18n'
import { AlgoliaCatalogCourseType } from '@src/interfaces/AlgoliaResultCourseType'
import { searchClient } from '@src/services/algoliaClient'

import CourseHitList from './CourseHitList'

export type AlgoliaCourseHit = AlgoliaHit<AlgoliaCatalogCourseType>

type Props = {
  hitsHeight?: string
  hitsPerPage?: number
}

export default function Search({ hitsHeight, hitsPerPage = 4 }: Props) {
  return (
    <InstantSearch
      indexName={process.env.GATSBY_ALGOLIA_KEYWORDS_EDGENDA_INDEX_NAME}
      searchClient={searchClient}
    >
      <Configure hitsPerPage={hitsPerPage} filters={`locale:'${i18n.language}'`} />
      <CustomSearchBox />
      <CourseHitList hitsHeight={hitsHeight} />
      <CustomPagination />
    </InstantSearch>
  )
}
